export const OP_APP_DEF_ID = '2936472a-a1ed-4ae5-9f71-614313a9f4e7';
